module.exports = "@media (max-width: 700px) {\n  .popover {\n    left: 0 !important;\n    right: 0 !important; } }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/blocks/blocks.component.scss
// module id = ./src/app/blocks/blocks.component.scss
// module chunks = main